import * as React from 'react'
import { toggleCreateItemModal } from './Items'
import { FormattedMessage } from 'react-intl'
import { useDispatch } from 'react-redux'
import { Item } from '../types'
import { useItems } from './Items/queries'
import { Button, Select } from 'antd'

type Props = {
  value?: Item
  onChange?: (_: Item) => void
  selected?: number[]
}

const SelectItem = ({ value, onChange, selected }: Props) => {
  const [name, setName] = React.useState<string>()
  const itemsQuery = useItems({ page: 0, itemsPerPage: 50, name })
  const dispatch = useDispatch()
  const options = !!selected
    ? itemsQuery.data?.data.filter(i => !selected.find(s => s === i.id))
    : itemsQuery.data?.data

  return (
    <Select<string, { option: Item }>
      onSearch={name => setName(name)}
      loading={itemsQuery.isLoading}
      onSelect={(_: string, { option }: { option: Item }) => {
        onChange?.(option)
        setName(option.name)
      }}
      value={name ?? value?.name}
    >
      <Select.Option disabled value="add" key="add">
        <Button
          style={{ width: '100%' }}
          type="ghost"
          onClick={e => {
            e.stopPropagation()
            e.preventDefault()
            dispatch(toggleCreateItemModal())
          }}
        >
          <FormattedMessage id="newItem" />,
        </Button>
      </Select.Option>
      {options?.map(i => (
        <Select.Option value={i.id} key={i.id} option={i}>
          {i.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectItem
